import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20h16","key":"svg-0"}],["path",{"d":"M8 16v-8a4 4 0 1 1 8 0v8","key":"svg-1"}],["path",{"d":"M8 10h8","key":"svg-2"}]]

const IconBaseline = createReactComponent('outline', 'baseline', 'Baseline', __iconNode);

export default IconBaseline;